import { UserData, UserRole } from "../../actions/authentificationActions";
import { AppState } from "../../store/configureStore";
import { useSelector } from "react-redux";
import { Breadcrumbs } from "../../components/Breadcrumbs/Breadcrumbs";
import { Redirect } from "react-router-dom";
import { ParameterOverviewTable } from "../../components/ParameterOverviewTable/ParameterOverviewTable";
import { Legend } from "../../components/Legend/Legend";

export const ParameterOverview = () => {
    const user: UserData = useSelector((state: AppState) => state.user);

    return user.role === UserRole.Viewer ? (
        <Redirect to="/unauthorized" />
    ) : (
        <>
            <div className="input-data-editor-container">
                <div className="container-header">
                    <h1>Parameter overview</h1>
                </div>
                <Breadcrumbs />
                <Legend new partial submitted closedNotSubmitted />
                <ParameterOverviewTable />
            </div>
        </>
    );
};
